/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { FrequencyBand } from "../../models/frequency-band";
import { KpiTypeAerohive } from "../../models/kpi-type-aerohive";
import { KpiTypeAruba } from "../../models/kpi-type-aruba";
import { KpiTypeGeneral } from "../../models/kpi-type-general";
import { WirelessStats } from "../../models/wireless-stats";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetWirelessKpi$Params {
  subscription_id: string;
  kpi_type: KpiTypeGeneral | KpiTypeAerohive | KpiTypeAruba;
  frequency?: FrequencyBand;
  start?: number | null;
  end?: number | null;
  step?: number;
  raw?: boolean;
}

export function getWirelessKpi(
  http: HttpClient,
  rootUrl: string,
  params: GetWirelessKpi$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<WirelessStats>> {
  const rb = new RequestBuilder(rootUrl, getWirelessKpi.PATH, "get");
  if (params) {
    rb.path("subscription_id", params.subscription_id, {});
    rb.path("kpi_type", params.kpi_type, {});
    rb.query("frequency", params.frequency, {});
    rb.query("start", params.start, {});
    rb.query("end", params.end, {});
    rb.query("step", params.step, {});
    rb.query("raw", params.raw, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json; charset&#x3D;utf-8", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WirelessStats>;
    }),
  );
}

getWirelessKpi.PATH = "/dashboard/stats/wireless/{subscription_id}/{kpi_type}";
